module.exports = __webpack_public_path__ + "static/media/mail.ae7e47dd.svg";